import { render, staticRenderFns } from "./CustomerQryList.vue?vue&type=template&id=16c84d44&scoped=true"
import script from "./CustomerQryList.vue?vue&type=script&lang=js"
export * from "./CustomerQryList.vue?vue&type=script&lang=js"
import style0 from "./CustomerQryList.vue?vue&type=style&index=0&id=16c84d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c84d44",
  null
  
)

export default component.exports